// @flow

import React, { type Node, type StatelessFunctionalComponent } from "react";

import { MdErrorOutline, MdRefresh } from "react-icons/md";

import { useI18n } from "@quantum/i18n";

import "./erro-carregamento.css";

type Props = {
  children?: Node,
  retry?: () => mixed,
};

const ErroCarregamento: StatelessFunctionalComponent<Props> = ({
  children,
  retry,
}) => {
  const { translate } = useI18n();

  return (
    <div className="ErroCarregamento">
      <MdErrorOutline className="ErroCarregamento__icone" />
      <div className="ErroCarregamento__mensagem">
        {children ||
          translate("Comum.Msg.ErroCarregarDados") ||
          "Erro ao carregar dados"}
      </div>
      {retry && (
        <button className="ErroCarregamento__botao-retry" onClick={retry}>
          <MdRefresh className="ErroCarregamento__icone-retry" />
          {translate("Comum.Msg.NovaTentativa") ||
            "Clique para tentar novamente"}
        </button>
      )}
    </div>
  );
};

export default ErroCarregamento;
